/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateProcessTemplateRequestDto } from '../models';
// @ts-ignore
import type { ProcessTemplateDto } from '../models';
// @ts-ignore
import type { UpdateProcessTemplateRequestDto } from '../models';
/**
 * ProcessTemplateRestApi - axios parameter creator
 */
export const ProcessTemplateRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a process template
         * @param {CreateProcessTemplateRequestDto} createProcessTemplateRequestDto Process template details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessTemplate: async (createProcessTemplateRequestDto: CreateProcessTemplateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProcessTemplateRequestDto' is not null or undefined
            assertParamExists('createProcessTemplate', 'createProcessTemplateRequestDto', createProcessTemplateRequestDto)
            const localVarPath = `/api/v1/processes/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProcessTemplateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a process template
         * @param {number} id Process template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessTemplate: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProcessTemplate', 'id', id)
            const localVarPath = `/api/v1/processes/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get process template details
         * @param {number} id Process template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessTemplate: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProcessTemplate', 'id', id)
            const localVarPath = `/api/v1/processes/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all process templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/processes/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a process template
         * @param {number} id Process template ID
         * @param {UpdateProcessTemplateRequestDto} updateProcessTemplateRequestDto Process template details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessTemplate: async (id: number, updateProcessTemplateRequestDto: UpdateProcessTemplateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProcessTemplate', 'id', id)
            // verify required parameter 'updateProcessTemplateRequestDto' is not null or undefined
            assertParamExists('updateProcessTemplate', 'updateProcessTemplateRequestDto', updateProcessTemplateRequestDto)
            const localVarPath = `/api/v1/processes/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessTemplateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessTemplateRestApi - functional programming interface
 */
export const ProcessTemplateRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessTemplateRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a process template
         * @param {CreateProcessTemplateRequestDto} createProcessTemplateRequestDto Process template details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcessTemplate(createProcessTemplateRequestDto: CreateProcessTemplateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcessTemplate(createProcessTemplateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessTemplateRestApi.createProcessTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a process template
         * @param {number} id Process template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcessTemplate(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcessTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessTemplateRestApi.deleteProcessTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get process template details
         * @param {number} id Process template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessTemplate(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessTemplateRestApi.getProcessTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all process templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessTemplateRestApi.getProcessTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a process template
         * @param {number} id Process template ID
         * @param {UpdateProcessTemplateRequestDto} updateProcessTemplateRequestDto Process template details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessTemplate(id: number, updateProcessTemplateRequestDto: UpdateProcessTemplateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessTemplate(id, updateProcessTemplateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessTemplateRestApi.updateProcessTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessTemplateRestApi - factory interface
 */
export const ProcessTemplateRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessTemplateRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a process template
         * @param {CreateProcessTemplateRequestDto} createProcessTemplateRequestDto Process template details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessTemplate(createProcessTemplateRequestDto: CreateProcessTemplateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createProcessTemplate(createProcessTemplateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a process template
         * @param {number} id Process template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessTemplate(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProcessTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get process template details
         * @param {number} id Process template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessTemplate(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessTemplateDto> {
            return localVarFp.getProcessTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all process templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessTemplates(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessTemplateDto>> {
            return localVarFp.getProcessTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a process template
         * @param {number} id Process template ID
         * @param {UpdateProcessTemplateRequestDto} updateProcessTemplateRequestDto Process template details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessTemplate(id: number, updateProcessTemplateRequestDto: UpdateProcessTemplateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessTemplate(id, updateProcessTemplateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessTemplateRestApi - interface
 */
export interface ProcessTemplateRestApiInterface {
    /**
     * 
     * @summary Create a process template
     * @param {CreateProcessTemplateRequestDto} createProcessTemplateRequestDto Process template details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProcessTemplate(createProcessTemplateRequestDto: CreateProcessTemplateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @summary Delete a process template
     * @param {number} id Process template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcessTemplate(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get process template details
     * @param {number} id Process template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessTemplate(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessTemplateDto>;

    /**
     * 
     * @summary Get all process templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessTemplates(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessTemplateDto>>;

    /**
     * 
     * @summary Update a process template
     * @param {number} id Process template ID
     * @param {UpdateProcessTemplateRequestDto} updateProcessTemplateRequestDto Process template details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessTemplate(id: number, updateProcessTemplateRequestDto: UpdateProcessTemplateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ProcessTemplateRestApi - object-oriented interface
 */
export class ProcessTemplateRestApi extends BaseAPI implements ProcessTemplateRestApiInterface {
    /**
     * 
     * @summary Create a process template
     * @param {CreateProcessTemplateRequestDto} createProcessTemplateRequestDto Process template details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcessTemplate(createProcessTemplateRequestDto: CreateProcessTemplateRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessTemplateRestApiFp(this.configuration).createProcessTemplate(createProcessTemplateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a process template
     * @param {number} id Process template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcessTemplate(id: number, options?: RawAxiosRequestConfig) {
        return ProcessTemplateRestApiFp(this.configuration).deleteProcessTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get process template details
     * @param {number} id Process template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessTemplate(id: number, options?: RawAxiosRequestConfig) {
        return ProcessTemplateRestApiFp(this.configuration).getProcessTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all process templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessTemplates(options?: RawAxiosRequestConfig) {
        return ProcessTemplateRestApiFp(this.configuration).getProcessTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a process template
     * @param {number} id Process template ID
     * @param {UpdateProcessTemplateRequestDto} updateProcessTemplateRequestDto Process template details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessTemplate(id: number, updateProcessTemplateRequestDto: UpdateProcessTemplateRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessTemplateRestApiFp(this.configuration).updateProcessTemplate(id, updateProcessTemplateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

